import axios from "axios";

let baseURL =
  // process.env.NODE_ENV == "production"
  //   ?
  `${process.env.REACT_APP_BACKEND_URL}/v1`;
// : "http://localhost:5000/api/v1";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL,
});

const setAuthToken = (token) => {
  if (token) {
    const cleaned = token.replace(/^"|"$/g, "");
    api.defaults.headers.common["auth-token"] = cleaned;
  } else {
    delete api.defaults.headers.common["auth-token"];
  }
};

// Set initial token if available
setAuthToken(localStorage.getItem("token"));

export { api, setAuthToken };
